import BarWidget from '@appblocks/codegeneration/Widgets/BarWidget';
import ButtonWidget from '@appblocks/codegeneration/Widgets/ButtonWidget';
import CardWidget from '@appblocks/codegeneration/Widgets/CardWidget';
import GaugeWidget from '@appblocks/codegeneration/Widgets/GaugeWidget';
import LCDCardWidget from '@appblocks/codegeneration/Widgets/LCDCardWidget';
import LCDImageWidget from '@appblocks/codegeneration/Widgets/LCDImageWidget';
import LCDGraphWidget from '@appblocks/codegeneration/Widgets/LCDGraphWidget';
import LCDTextWidget from '@appblocks/codegeneration/Widgets/LCDTextWidget';
import LineWidget from '@appblocks/codegeneration/Widgets/LineWidget';
import SliderWidget from '@appblocks/codegeneration/Widgets/SliderWidget';
import SwitchWidget from '@appblocks/codegeneration/Widgets/SwitchWidget';
import TextWidget from '@appblocks/codegeneration/Widgets/TextWidget';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';

const WidgetsMap: { [featureId: string]: any } = {
    bar_widget: BarWidget,
    button_widget: ButtonWidget,
    card_widget: CardWidget,
    gauge_widget: GaugeWidget,
    // lcd_card_widget: LCDCardWidget,
    lcd_image_widget: LCDImageWidget,
    lcd_graph_widget: LCDGraphWidget,
    lcd_text_widget: LCDTextWidget,
    line_widget: LineWidget,
    slider_widget: SliderWidget,
    switch_widget: SwitchWidget,
    text_widget: TextWidget,
};

export default class Widgets {
    static getItem(itemId: string, project: ProjectConfiguration): any {
        if (WidgetsMap[itemId] !== undefined) {
            return new WidgetsMap[itemId]();
        }
        return undefined;
    }

    static getList() {
        return Object.keys(WidgetsMap);
    }
}
